import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Dropdown } from 'antd';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import IconChevronDown from '@assets/icon-chevron-down.svg?react';
import { EPButton } from '@/components';
import { AlertLevels } from '@/constants/enums';
import SeverityIcon from '@/comp/common/icons/SeverityIcon';

import IconAlarm from './components/IconAlarm';

const DropdownAlarm = observer(({ onChange, ...rest }) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState(AlertLevels.All);

  const items = [
    {
      key: AlertLevels.All,
      label: t('All'),
    },
    {
      key: AlertLevels.Shutdown,
      label: (
        <DropdownItem>
          <SeverityIcon severity={AlertLevels.Shutdown} />
          &nbsp;&nbsp;{t('Shutdown')}
        </DropdownItem>
      ),
    },
    {
      key: AlertLevels.Warning,
      label: (
        <DropdownItem>
          <SeverityIcon severity={AlertLevels.Warning} />
          &nbsp;&nbsp;{t('Warning')}
        </DropdownItem>
      ),
    },
    {
      key: AlertLevels.Service,
      label: (
        <DropdownItem>
          <SeverityIcon severity={AlertLevels.Service} />
          &nbsp;&nbsp;{t('Service')}
        </DropdownItem>
      ),
    },
    {
      key: 'none',
      label: t('none'),
    },
  ];

  useEffect(() => {
    onChange && onChange(AlertLevels.All);
  }, []);

  const isActive = () => {
    return [AlertLevels.All, AlertLevels.Shutdown, AlertLevels.Warning, AlertLevels.Service].includes(selected);
  };

  const onClickHandler = ({ key }) => {
    setSelected(key);
    onChange && onChange(key);
  };

  return (
    <Dropdown menu={{ items, selectable: true, defaultSelectedKeys: selected, onClick: onClickHandler }} {...rest}>
      <EPButton>
        <IconWrapper>
          <IconAlarm active={isActive()} />
          <IconChevronDown />
        </IconWrapper>
      </EPButton>
    </Dropdown>
  );
});

const DropdownItem = styled.div`
  display: flex;
  align-items: center;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default DropdownAlarm;
